export default "__VITE_ASSET__D3_xXH1j__"